import { CategoryApiFacade } from "../category/category.api-facade";
import { LookupType } from "./lookup-type.model";
import { Observable } from "rxjs/Observable";
import { ApiRequestOptions } from "../../../core/services/api/request-options";

export class LookupTypeApiFacade extends CategoryApiFacade<LookupType> {

    get(accountId: string, id: string, options?: ApiRequestOptions): Observable<LookupType> {
        return this.GET(`/accounts/${accountId}/lookuptypes/${id}`, options)
            .map(object => new LookupType(object));
    }

    getAll(accountId: string, options?: ApiRequestOptions): Observable<Array<LookupType>> {
        return this.CGET(`/accounts/${accountId}/lookuptypes`, options)
            .map(objects => objects.map(object => new LookupType(object)));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/lookup-type/lookup-type.api-facade.ts